import { createFileRoute } from "@tanstack/react-router";
import { CreateFourniturePage } from "@/features/achats/components/fournitures/CreateFourniturePage";

export const Route = createFileRoute("/_app/achats/fournitures/create")({
  staticData: {
    title: "Nouvelle fourniture",
    showInBreadcrumb: true,
  },
  component: CreateFourniturePage,
});
